import { IBonus } from './bonus.types';

export class User {
  public id: string;
  public firstName: string;
  public lastName: string;
  public userName: string;
  public email: string;
  public enabled: boolean;
  public groupName: User.GroupName[];
}

export namespace User {
  export enum GroupName {
    ADMIN = 'ADMIN',
    STANDARD = 'STANDARD',
    VIEWER = 'VIEWER',
    INACTIVE = 'INACTIVE',
  }
}

export class InvitationPayload {
  public firstName: string;
  public lastName: string;
  public email: string;
  public group: User.GroupName;
  public sellersIds?: string[];
  public brands?: string[];
}

export class UserInvitation extends InvitationPayload {
  public id: string;
  public status: string;
  public type: string;
  public whitelabelHash?: string;
  public sellers?: string[];
}

export namespace UserInvitation {
  export enum Status {
    WAITING = 'WAITING',
    CONFIRMED = 'CONFIRMED',
    EXPIRED = 'EXPIRED',
    ERROR = 'ERROR',
    CANCELLED = 'CANCELLED',
  }
  export enum Type {
    ACCOUNT = 'ACCOUNT',
    WHITELABEL = 'WHITELABEL'
  }
}

/**
 * @todo: I think we don't need this type so it can be removed
 */
export interface IUserBonus extends Omit<IBonus, 'internalDescription'> {
  walletStatus: string | null;
}
